import { render } from "./Piping.vue?vue&type=template&id=fbbb0c52"
import script from "./Piping.vue?vue&type=script&lang=js"
export * from "./Piping.vue?vue&type=script&lang=js"

import exportComponent from "/home/abdelghafour/Desktop/Apps/helpdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__